export default __webpack_public_path__ + "static/media/ring.65a18837.gif";